import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { name: "CreateEditNotice" }
const _hoisted_2 = { class: "vstack gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_4 = {
  class: "alert alert-danger fade show",
  role: "alert"
}
const _hoisted_5 = { class: "list-group" }
const _hoisted_6 = {
  class: "ms-3",
  style: {"list-style-type":"disc"}
}
const _hoisted_7 = { class: "bg-light" }
const _hoisted_8 = { class: "pb-2" }
const _hoisted_9 = { class: "pb-2" }
const _hoisted_10 = { class: "pb-2" }
const _hoisted_11 = { class: "pb-2" }
const _hoisted_12 = { class: "pb-2" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }

import {ref, computed, watch, onMounted} from "vue";
import {Death, DeathForm} from "./schema";
import {useDcraStore} from "@/stores/dcraStore";
import FormModal from "../Misc/FormModal.vue";
import SelectField from "@/components/Misc/SelectField.vue";
import {BInput, BTextarea, BAgency, BDatePicker} from "@/components/Fields";
import {array, date, number, object, string, ValidationError} from "yup";
import {useFormValidation} from "@/validation";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateEditDeath',
  props: /*@__PURE__*/_mergeModels({
    death: {},
    startDate: {}
  }, {
    "modelValue": {type: Boolean},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["dismiss", "submit", "update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const modelValue = _useModel(__props, "modelValue");
const props = __props;
const emit = __emit;

var dcraStore = useDcraStore();

const {handleSubmit, errors, resetValidation} = useFormValidation();

const form = ref({
    agency: "",
    lastName: "",
    firstName: "",
    middleName: "",
    sex: "",
    race: [],
    ethnicity: "",
    birthYear: "",
    dateOfDeath: undefined,
    locationName: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    eventLocationType: "",
    mannerOfDeath: "",
    investigatingAgency: "",
    details: "",
    eventDescription: "",
} as DeathForm);

const schema = object<DeathForm>({
    agency: string().required("Agency is a required field"),
    lastName: string()
        .required("Last name is a required field")
        .matches(/^[0-9a-zA-Z, .\-\']*$/, "Input contains invalid characters"),
    firstName: string()
        .required("First name is a required field")
        .matches(/^[0-9a-zA-Z, .\-\']*$/, "Input contains invalid characters"),
    middleName: string().matches(/^[0-9a-zA-Z, .\-\']*$/, "Input contains invalid characters"),
    sex: string().required("Sex is a required field"),
    race: array().required("Race is a required field").min(1),
    ethnicity: string().required("Ethnicity is a required field"),
    birthYear: number()
        .transform((value) => (Number.isNaN(value) ? null : value))
        .min(new Date().getFullYear() - 123)
        .required(),
    dateOfDeath: date().required("Date of death is a required field"),
    locationName: string().matches(/^[0-9a-zA-Z!@#$%, .\-\']*$/, "Input contains invalid characters"),
    streetAddress: string()
        .required("Street address is a required field")
        .matches(/^[0-9a-zA-Z!@#$%, .\-\']*$/, "Input contains invalid characters"),
    city: string()
        .required("City is a required field")
        .matches(/^[0-9a-zA-Z!@#$%, .\-\']*$/, "Input contains invalid characters"),
    state: string().required().max(2),
    zipCode: string()
        .matches(/^\d{5}(-\d{4})?$/, "Zipcode must be in the format 12345 or 12345-6789")
        .required("Zipcode is a required field")
        .max(10),
    eventLocationType: string().required("Event location is a required field"),
    mannerOfDeath: string().required("Manner of death is a required field"),
    investigatingAgency: string().max(500),
    details: string().matches(/^[0-9a-zA-Z!@#$%, .\-\']*$/, "Input contains invalid characters").max(500),
    eventDescription: string().required("Event Description is a required field").max(500),
});

var submitDisabled = ref(false);
var dcraErrors = ref([] as string[]);
//Computed
const title = computed(() => (props.death?.id > 0 ? "Edit Death" : "Add Death"));

//FUNctions
const submitForm = async () => {
    if (await handleSubmit(schema, form.value)) {
        if (props.death?.id > 0) {
            await dcraStore.editDeath(props.death.id, form.value);
        } else {
            await dcraStore.createDeath(form.value);
        }

        window.location.href = "dataupload.aspx?source=8";
    }
};

const setFormValues = async () => {
    resetValidation();

    if (props.death.id > 0) {
        var response = await dcraStore.fetchDeath(props.death.id);

        if (response.status == 200) {
            let deathForm = response.data;
            form.value = deathForm;
        }
    } else {
        form.value = {
            agency: "",
            lastName: "",
            firstName: "",
            middleName: "",
            sex: "",
            race: [],
            ethnicity: "",
            birthYear: "",
            dateOfDeath: undefined,
            locationName: "",
            streetAddress: "",
            city: "",
            state: "",
            zipCode: "",
            eventLocationType: "",
            mannerOfDeath: "",
            investigatingAgency: "",
            details: "",
            eventDescription: "",
        } as DeathForm;
    }
};

const getItemErrors = async () => {
    dcraErrors.value = [] as string[];

    if (props.death?.id > 0) {
        let response = await dcraStore.getDeathErrors(props.death.id);

        if (response != null && response.status == 200) {
            dcraErrors.value = response.data ?? ([] as string[]);
        }
    }
};
//LifeCycle Hooks
onMounted(async () => {
    await dcraStore.fetchCodeLabelByKind();
    await setFormValues();
    await getItemErrors();
});

//Watches
watch(
    () => props.death,
    async () => {
        await setFormValues();
        await getItemErrors();
    }
);

watch(
    () => form.value,
    async () => {
        try {
            if (errors.value.length == 0) {
                return;
            }

            errors.value = Array.isArray(errors.value) ? [] : {};
            await schema.validate(form.value, {abortEarly: false});
        } catch (err) {
            const error = err as ValidationError;
            if (error.name !== "ValidationError") throw err;

            // Build an object map of field -> message
            const newErrors: Record<string, string> = {};
            error.inner.forEach((it: ValidationError) => {
                if (it.path) newErrors[it.path] = it.message;
            });
            errors.value = newErrors;
        }
    },
    {deep: true}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(FormModal, {
      title: title.value,
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((modelValue).value = $event)),
      "submit-button": 'Submit',
      onSubmit: submitForm
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          (_unref(dcraErrors) && _unref(dcraErrors).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[20] || (_cache[20] = _createElementVNode("p", null, "Error(s):", -1)),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dcraErrors), (error) => {
                      return (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(error), 1))
                    }), 256))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { for: "agency" }, "Agency *", -1)),
            _createVNode(_unref(BAgency), {
              name: "agency",
              modelValue: form.value.agency,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.agency) = $event)),
              "can-clear": false,
              error: _unref(errors).agency,
              "select-first": true
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { for: "lastName" }, "Last Name *", -1)),
            _createVNode(_unref(BInput), {
              name: "lastName",
              type: "text",
              error: _unref(errors).lastName,
              required: "required",
              modelValue: form.value.lastName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.lastName) = $event))
            }, null, 8, ["error", "modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { for: "firstName" }, "First Name *", -1)),
            _createVNode(_unref(BInput), {
              name: "firstName",
              type: "text",
              error: _unref(errors).firstName,
              required: "required",
              modelValue: form.value.firstName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.firstName) = $event))
            }, null, 8, ["error", "modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { for: "middleName" }, "Middle Name", -1)),
            _createVNode(_unref(BInput), {
              name: "middleName",
              type: "text",
              error: _unref(errors).middleName,
              modelValue: form.value.middleName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.middleName) = $event))
            }, null, 8, ["error", "modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { for: "sex" }, "Sex *", -1)),
            _createVNode(SelectField, {
              class: "w-100",
              modelValue: form.value.sex,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.sex) = $event)),
              "select-items": _unref(dcraStore).getSex,
              mode: "single",
              error: _unref(errors).sex,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "race" }, "Race *", -1)),
            _createVNode(SelectField, {
              class: "w-100",
              modelValue: form.value.race,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.race) = $event)),
              "select-items": _unref(dcraStore).getRace,
              mode: "multiple",
              error: _unref(errors).race,
              min: 1,
              "include-show-all-option": false,
              "hide-selected": false,
              "close-on-select": false
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { for: "ethnicity" }, "Ethnicity *", -1)),
            _createVNode(SelectField, {
              class: "w-100",
              modelValue: form.value.ethnicity,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.ethnicity) = $event)),
              "select-items": _unref(dcraStore).getEthnicity,
              mode: "single",
              error: _unref(errors).ethnicity,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "birthYear" }, "Birth Year *", -1)),
            _createVNode(_unref(BInput), {
              name: "birthYear",
              type: "number",
              error: _unref(errors).birthYear,
              required: "required",
              modelValue: form.value.birthYear,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.birthYear) = $event)),
              min: new Date().getFullYear() - 123,
              placeholder: 'YYYY or 9999 for unknown'
            }, null, 8, ["error", "modelValue", "min"])
          ]),
          _createElementVNode("div", null, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { for: "dateOfDeath" }, "Date and Time of Death *", -1)),
            _createVNode(_unref(BDatePicker), {
              modelValue: form.value.dateOfDeath,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.dateOfDeath) = $event)),
              error: _unref(errors).dateOfDeath,
              "month-picker": false,
              "auto-apply": false,
              "enable-time-picker": true,
              "enable-minutes": true,
              "enable-seconds": false,
              "max-date": new Date(),
              "min-date": new Date(props.startDate),
              "auto-position": true
            }, null, 8, ["modelValue", "error", "max-date", "min-date"])
          ]),
          _createElementVNode("div", null, [
            _cache[30] || (_cache[30] = _createElementVNode("label", { for: "eventLocationType" }, "Event Location Type *", -1)),
            _createVNode(SelectField, {
              class: "w-100",
              modelValue: form.value.eventLocationType,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.eventLocationType) = $event)),
              "select-items": _unref(dcraStore).getEventLocationType,
              mode: "single",
              error: _unref(errors).eventLocationType,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("fieldset", _hoisted_7, [
            _cache[36] || (_cache[36] = _createElementVNode("legend", { class: "fs-5" }, "Location of Death", -1)),
            _createElementVNode("div", _hoisted_8, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { for: "locationName" }, "Location Name", -1)),
              _createVNode(_unref(BInput), {
                name: "locationName",
                type: "text",
                error: _unref(errors).locationName,
                modelValue: form.value.locationName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.locationName) = $event))
              }, null, 8, ["error", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { for: "streetAddress" }, "Street Address *", -1)),
              _createVNode(_unref(BInput), {
                name: "streetAddress",
                type: "text",
                error: _unref(errors).streetAddress,
                required: "required",
                modelValue: form.value.streetAddress,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.streetAddress) = $event))
              }, null, 8, ["error", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { for: "city" }, "City *", -1)),
              _createVNode(_unref(BInput), {
                name: "city",
                type: "text",
                error: _unref(errors).city,
                required: "required",
                modelValue: form.value.city,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.city) = $event))
              }, null, 8, ["error", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { for: "state" }, "State *", -1)),
              _createVNode(SelectField, {
                class: "w-100",
                modelValue: form.value.state,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.state) = $event)),
                "select-items": _unref(dcraStore).getState,
                mode: "single",
                error: _unref(errors).state,
                min: 1
              }, null, 8, ["modelValue", "select-items", "error"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { for: "zipCode" }, "Zip Code *", -1)),
              _createVNode(_unref(BInput), {
                name: "zipCode",
                type: "text",
                error: _unref(errors).zipCode,
                required: "required",
                modelValue: form.value.zipCode,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.zipCode) = $event)),
                maxlength: 10
              }, null, 8, ["error", "modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { for: "mannerOfDeath" }, "Manner of Death *", -1)),
            _createVNode(SelectField, {
              class: "w-100",
              modelValue: form.value.mannerOfDeath,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.mannerOfDeath) = $event)),
              "select-items": _unref(dcraStore).getMannerOfDeath,
              mode: "single",
              error: _unref(errors).mannerOfDeath,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          (form.value.mannerOfDeath === 'I')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { for: "investigatingAgency" }, "Agency investigating death and expected completion date", -1)),
                _createVNode(_unref(BTextarea), {
                  name: "investigatingAgency",
                  error: _unref(errors).investigatingAgency,
                  modelValue: form.value.investigatingAgency,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.investigatingAgency) = $event)),
                  "max-length": 500
                }, null, 8, ["error", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          (form.value.mannerOfDeath === 'O')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[39] || (_cache[39] = _createElementVNode("label", { for: "details" }, "Details", -1)),
                _createVNode(_unref(BTextarea), {
                  name: "details",
                  "aria-required": "false",
                  error: _unref(errors).details,
                  modelValue: form.value.details,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.details) = $event))
                }, null, 8, ["error", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _cache[40] || (_cache[40] = _createElementVNode("label", { for: "eventDescription" }, "Event Description *", -1)),
            _createVNode(_unref(BTextarea), {
              name: "eventDescription",
              "aria-required": "true",
              required: "required",
              error: _unref(errors).eventDescription,
              modelValue: form.value.eventDescription,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.eventDescription) = $event))
            }, null, 8, ["error", "modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})